module.exports = __webpack_public_path__ + "d5ae9d4ccde1c465009a9621709e0ff1.svg";